import './HowToResolveConflictsStepModal.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Radio } from '../../../../../../../../design/inputs/radio/S_Radio';
import { S_ConfirmationModal } from '../../../../../../../../design/modals/confirmationModal/S_ConfirmationModal';
import { ResolveConflictsStrategy } from '../../../models/ResolveConflictsStrategy';

interface IProps {
  show: boolean;
  conflictsCount: number;
  resolveConflictsStrategy: ResolveConflictsStrategy;
  onChangeStrategy: (strategy: ResolveConflictsStrategy) => void;
  onHide: () => void;
  onSubmit: () => Promise<void>;
}

export const HowToResolveConflictsStepModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { show, resolveConflictsStrategy, onChangeStrategy, onHide, onSubmit } = props;
  const selectKeepAllStrategy = (): void => {
    onChangeStrategy(ResolveConflictsStrategy.KeepAll);
  };
  const selectReplaceAllStrategy = (): void => {
    onChangeStrategy(ResolveConflictsStrategy.ReplaceAll);
  };
  const selectManuallyStrategy = (): void => {
    onChangeStrategy(ResolveConflictsStrategy.Manually);
  };

  return (
    <S_ConfirmationModal
      cancelText={t('new.projects.details.import_annotations.cancel')}
      headerText={`${t('new.projects.details.import_annotations.header')} - ${t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.header')}`}
      submitText={t('new.projects.details.import_annotations.next')}
      onCancel={onHide}
      toggle={onHide}
      onSubmit={onSubmit}
      isOpen={show}
      className='resolve-conflicts-modal'
    >
      <p>
        {props.conflictsCount}{' '}
        {t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.conflicted_annotations_found', { count: props.conflictsCount })}
      </p>
      <p>{t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.what_would_you_like_to_do')}</p>
      <S_Radio
        id='option-keep'
        className='form-check'
        checked={resolveConflictsStrategy === ResolveConflictsStrategy.KeepAll}
        label={t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.skip_annotations')}
        onClick={selectKeepAllStrategy}
      />
      <S_Radio
        id='option-replace'
        className='form-check'
        checked={resolveConflictsStrategy === ResolveConflictsStrategy.ReplaceAll}
        label={t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.replace_existing_annotations')}
        onClick={selectReplaceAllStrategy}
      />
      <S_Radio
        id='option-manually'
        className='form-check'
        checked={resolveConflictsStrategy === ResolveConflictsStrategy.Manually}
        label={t('new.projects.details.import_annotations.steps.how_to_resolve_conflicts.let_me_decide')}
        onClick={selectManuallyStrategy}
      />
    </S_ConfirmationModal>
  );
});
